import * as axios from "axios";
import { getAuthHeader } from "../utils";

export const getparkedFileList = async () => {
  const url = `${process.env.REACT_APP_BASE_URL}get-parked-file-list`;
  return axios.get(url, getAuthHeader()).then(
    (response) => {
      return response.data;
    },
    (error) => {
      alert(error.Message);
    }
  );
};
